module.exports = __webpack_public_path__ + "static/media/book_img.a34401f7.svg";